var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlantSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.80028 31.8124C3.26661 31.8124 2.83398 31.3798 2.83398 30.8461V15.4277C2.83398 15.0401 3.0656 14.69 3.42232 14.5383L12.744 10.5766V13.4081L19.8226 10.5766V14.8238H31.1483V30.8461C31.1483 31.3798 30.7157 31.8124 30.182 31.8124H3.80028ZM5.66542 28.981H28.3169V17.6552H16.9912V14.753L9.91257 17.5844V14.8238L5.66542 16.6996V28.981ZM15.5754 26.1495H18.4069V20.4867H15.5754V26.1495ZM9.91257 26.1495H12.744V20.4867H9.91257V26.1495ZM21.2383 26.1495H24.0697V20.4867H21.2383V26.1495ZM31.1483 14.8238H24.0697L25.3797 4.34449C25.4401 3.86093 25.8512 3.49805 26.3385 3.49805H28.8796C29.3669 3.49805 29.778 3.86093 29.8384 4.34449L31.1483 14.8238Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantSelected);
export default __webpack_public_path__ + "static/media/plantSelected.796436bdeafcddfcba6463f87c2a6102.svg";
export { ForwardRef as ReactComponent };